import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// SEC: withCredentials=true so the httpOnly session cookie is sent on every
// request. The auth token is no longer stored in localStorage — this mitigates
// XSS-based token theft.
const api = axios.create({ baseURL: API, withCredentials: true });

const PUBLIC_PATHS = ["/", "/login", "/influencer-signup", "/guide", "/onebuy"];

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const p = window.location.pathname;
      const isPublic = PUBLIC_PATHS.some((pp) => p === pp || p.startsWith(pp + "/"));
      if (!isPublic) window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export default api;
export { BACKEND_URL };
